import { defineComponent as _defineComponent } from 'vue'
import {
  nextTick,
  onMounted,
  ref,
  useContext,
  useRouter,
} from '@nuxtjs/composition-api'
import { useDebounceFn, watchIgnorable } from '@vueuse/core'

type SearchResult = {
  id: string
  value: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImpersonationModal',
  props: {
    message: null,
    search: null
  },
  emits: ["selected", "search", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'selected', selection: string): void
  (e: 'search', term: string): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  message: string
  search: (searchTerm: string) => Promise<Array<SearchResult>>
};

const router = useRouter()





const searchTerm = ref('')
const searchResults = ref<SearchResult[]>()
const doSearch = useDebounceFn(async (term: string) => {
  searchResults.value = await props.search(term)
})
const { ignoreUpdates: ignoreSearchTermUpdate } = watchIgnorable(
  () => searchTerm.value,
  (term) => {
    if (term.length >= MinimumSearchLength) {
      doSearch(term)
    } else {
      searchResults.value = []
    }
  }
)

const searchBoxRef = ref()
const selectedItem = ref<string | null>(null)

function selectSearchItem(item: SearchResult) {
  ignoreSearchTermUpdate(() => {
    searchTerm.value = item.value
  })
  selectedItem.value = item.id
  searchResults.value = []
  searchBoxRef.value?.$el.querySelector('input')?.focus()
}

function onEnter() {
  if (selectedItem.value != null) {
    select()
  }
}

function select() {
  if (selectedItem.value != null) {
    emit('selected', selectedItem.value)
  }
  emit('close')
}

const MinimumSearchLength = 3

function closeDialog() {
  emit('close')
}

onMounted(() => {
  nextTick(() => {
    searchBoxRef.value?.$el.querySelector('input')?.focus()
  })
})

return { __sfc: true,router, emit, props, searchTerm, searchResults, doSearch, ignoreSearchTermUpdate, searchBoxRef, selectedItem, selectSearchItem, onEnter, select, MinimumSearchLength, closeDialog }
}

})